// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-container[data-v-1e093ace]{width:100%;height:100%}.wrap[data-v-1e093ace]{margin:20px auto 0;width:calc(var(--inner-width)*1px);height:100%}[data-v-1e093ace] .el-tabs__item{text-align:center!important;font-size:20px}[data-v-1e093ace] .el-tabs__item.is-active{color:var(--main-theme-color);background-color:#d4d4d4}[data-v-1e093ace] .el-tabs__active-bar{background-color:var(--main-theme-color)}", ""]);
// Exports
module.exports = exports;
